import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MESSAGE_SERVICE_KEY } from '../constants';
import { ApiResponse, Category, GetYatraVM, PurposeType, ResultType, YatraInterestRequest, YatraVM } from '../models/avbhakthi.model';
import { AppHttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class YatraService {

  constructor(
    private http: AppHttpService,
    private messageService: MessageService
  ) { }

  getYatras(count: number, cat: Category, purpose: PurposeType, include: boolean, resultType: ResultType, lastNewsId: string = ""): Observable<YatraVM[]> {

    let getNewsReq = new GetYatraVM();
    getNewsReq.CATEGORY = cat;
    getNewsReq.NO_OF_NEWS = count;
    getNewsReq.DISPLAY_PURPOSE = purpose;
    getNewsReq.IS_INCLUDE = include;
    getNewsReq.RESULT_TYPE = resultType;
    getNewsReq.LAST_YATRA_ID = lastNewsId;
    return this.http.getYatras(getNewsReq);
  }

  postYatra(formData: FormData, isNew: boolean = true): Observable<ApiResponse> {
    if (isNew) {
      return this.http.postYatra(formData).pipe(
        catchError(this.handleError)
      );
    } else {
      return this.http.updateYatra(formData).pipe(
        catchError(this.handleError)
      );
    }

  }

  saveYatraStatus(req: YatraInterestRequest): Observable<ApiResponse> {
    return this.http.saveYatraInterest(req).pipe(
      catchError(this.handleError)
    );
  }


  handleError(error: HttpErrorResponse) {
    // debugger;
    if (error.error instanceof ErrorEvent) {
      this.messageService.add({ severity: 'error', summary: error.error.message, key: MESSAGE_SERVICE_KEY})
    } else {
      // console.log(error);
      this.messageService.add({ severity: 'error', summary: 'Something bad happened please try later', key: MESSAGE_SERVICE_KEY})
    }
    return throwError(
      'Something bad happened; please try again later.');
  }
}
